/**
 * The welcome shown on top of the « Nouveautés » panel the first time it opens after the
 * application started evolving again: who to write to, and what changed in the way the
 * application is built. It belongs to the release that introduced the panel, so a user who
 * has not seen that release yet (first production deployment, or a brand new account)
 * gets it, and a user who only misses a later release does not.
 */
export const PREFACE_RELEASE = '1.2.0';

export type Contact = { name: string; email: string };

export const contacts = {
  /** Who to write to about the application and its latest additions. */
  owners: [
    { name: 'Léo Lagarde', email: 'llagarde@equancy.com' },
    { name: 'Matteo Chayrigues', email: 'mchayrigues@equancy.com' },
  ] as Contact[],
  /** Business owner of the application, in copy. */
  sponsor: { name: 'Daniel Snook', email: 'dsnook@equancy.com' } as Contact,
};
